import { FatalScreenShell } from './fatal-screen-shell';

export interface VersionMismatchScreenProps {
	serverVersion: string;
	clientVersion: string;
	onBackToLauncher?: () => void;
}

/**
 * Rendered when the kernel closes with 4426 (version-mismatch). The only
 * safe action is to refresh — the cached JS bundle is incompatible with the
 * server. Offering "retry" without a reload would just reproduce the failure.
 */
export function VersionMismatchScreen({ serverVersion, clientVersion, onBackToLauncher }: VersionMismatchScreenProps) {
	return (
		<FatalScreenShell
			iconColor="var(--khal-status-warning)"
			title="A new version is available"
			description={
				<>
					The server is running version <b>{serverVersion}</b>, but this app is still on{' '}
					<b>{clientVersion}</b>. Reload to pick up the latest code.
				</>
			}
			primary={{
				label: 'Reload',
				onClick: () => {
					window.location.reload();
				},
				testId: 'version-reload',
			}}
			secondary={
				onBackToLauncher
					? {
							label: 'Back to Launcher',
							onClick: onBackToLauncher,
							testId: 'version-back',
						}
					: undefined
			}
		/>
	);
}
